import MessageChannelPolyfill from 'src/internal/transport/MessageChannelPolyfill';

// Polyfill for jsdom which doesn't support MessageChannel yet:
// https://github.com/jsdom/jsdom/issues/2448
export default typeof MessageChannel !== 'undefined'
  ? MessageChannel
  : MessageChannelPolyfill;
